import React, { Component } from 'react';
import { Warehouse } from 'lucide-react';
export function AuthoritySection() {
  return <section className="relative py-16 md:py-20" style={{
    backgroundImage: `url('https://cdn.magicpatterns.com/uploads/cxowPkQx5BXZx4efxtihqc/banner-bg1.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-18">
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gray-900/80" data-id="element-19" />

      <div className="relative z-10 max-w-5xl mx-auto px-4" data-id="element-20">
        <div className="text-center mb-10" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-22">
            Your Trusted Source for Industrial Components
          </h2>
        </div>

        <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 md:p-8 shadow-xl" data-id="element-23">
          {/* Centered logo image */}
          <div className="flex justify-center mb-6" data-id="element-24">
            <img src="https://cdn.magicpatterns.com/uploads/g2Efm7JU7HYPUW7FnFzr8T/logo-from-new-header.png" alt="USA Bearings & Belts" className="h-10 md:h-12 w-auto object-contain" data-id="element-25" />
          </div>

          <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-26">
            We carry a comprehensive selection of bearings and industrial
            products including shafting, roller chain, sprockets, pillow block
            bearings, flange units (2-bolt and 4-bolt), stainless steel ball
            bearings, thermoplastic mounted units, taper roller bearings, single
            and double row bearings, insert bearings, V-Belts, and much more.
          </p>

          <p className="text-gray-700 leading-relaxed" data-id="element-27">
            <strong className="text-gray-900" data-id="element-28">
              Moline Mounted Units are proudly manufactured in the USA.
            </strong>{' '}
            We deliver great bearings and exceptional value for your dollar,
            with multiple shipping locations throughout the country ensuring
            fast delivery to your facility.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-29">
          <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 text-center shadow-lg" data-id="element-30">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-31">
              {/* USA Flag Icon */}
              <svg className="w-8 h-8" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-32">
                <rect width="32" height="24" fill="#B22234" data-id="element-33" />
                <rect y="1.85" width="32" height="1.85" fill="white" data-id="element-34" />
                <rect y="5.54" width="32" height="1.85" fill="white" data-id="element-35" />
                <rect y="9.23" width="32" height="1.85" fill="white" data-id="element-36" />
                <rect y="12.92" width="32" height="1.85" fill="white" data-id="element-37" />
                <rect y="16.62" width="32" height="1.85" fill="white" data-id="element-38" />
                <rect y="20.31" width="32" height="1.85" fill="white" data-id="element-39" />
                <rect width="12.8" height="12.92" fill="#3C3B6E" data-id="element-40" />
                <g fill="white" data-id="element-41">
                  <circle cx="1.07" cy="1.08" r="0.6" data-id="element-42" />
                  <circle cx="3.2" cy="1.08" r="0.6" data-id="element-43" />
                  <circle cx="5.33" cy="1.08" r="0.6" data-id="element-44" />
                  <circle cx="7.47" cy="1.08" r="0.6" data-id="element-45" />
                  <circle cx="9.6" cy="1.08" r="0.6" data-id="element-46" />
                  <circle cx="11.73" cy="1.08" r="0.6" data-id="element-47" />
                  <circle cx="2.13" cy="2.15" r="0.6" data-id="element-48" />
                  <circle cx="4.27" cy="2.15" r="0.6" data-id="element-49" />
                  <circle cx="6.4" cy="2.15" r="0.6" data-id="element-50" />
                  <circle cx="8.53" cy="2.15" r="0.6" data-id="element-51" />
                  <circle cx="10.67" cy="2.15" r="0.6" data-id="element-52" />
                  <circle cx="1.07" cy="3.23" r="0.6" data-id="element-53" />
                  <circle cx="3.2" cy="3.23" r="0.6" data-id="element-54" />
                  <circle cx="5.33" cy="3.23" r="0.6" data-id="element-55" />
                  <circle cx="7.47" cy="3.23" r="0.6" data-id="element-56" />
                  <circle cx="9.6" cy="3.23" r="0.6" data-id="element-57" />
                  <circle cx="11.73" cy="3.23" r="0.6" data-id="element-58" />
                  <circle cx="2.13" cy="4.31" r="0.6" data-id="element-59" />
                  <circle cx="4.27" cy="4.31" r="0.6" data-id="element-60" />
                  <circle cx="6.4" cy="4.31" r="0.6" data-id="element-61" />
                  <circle cx="8.53" cy="4.31" r="0.6" data-id="element-62" />
                  <circle cx="10.67" cy="4.31" r="0.6" data-id="element-63" />
                  <circle cx="1.07" cy="5.38" r="0.6" data-id="element-64" />
                  <circle cx="3.2" cy="5.38" r="0.6" data-id="element-65" />
                  <circle cx="5.33" cy="5.38" r="0.6" data-id="element-66" />
                  <circle cx="7.47" cy="5.38" r="0.6" data-id="element-67" />
                  <circle cx="9.6" cy="5.38" r="0.6" data-id="element-68" />
                  <circle cx="11.73" cy="5.38" r="0.6" data-id="element-69" />
                  <circle cx="2.13" cy="6.46" r="0.6" data-id="element-70" />
                  <circle cx="4.27" cy="6.46" r="0.6" data-id="element-71" />
                  <circle cx="6.4" cy="6.46" r="0.6" data-id="element-72" />
                  <circle cx="8.53" cy="6.46" r="0.6" data-id="element-73" />
                  <circle cx="10.67" cy="6.46" r="0.6" data-id="element-74" />
                  <circle cx="1.07" cy="7.54" r="0.6" data-id="element-75" />
                  <circle cx="3.2" cy="7.54" r="0.6" data-id="element-76" />
                  <circle cx="5.33" cy="7.54" r="0.6" data-id="element-77" />
                  <circle cx="7.47" cy="7.54" r="0.6" data-id="element-78" />
                  <circle cx="9.6" cy="7.54" r="0.6" data-id="element-79" />
                  <circle cx="11.73" cy="7.54" r="0.6" data-id="element-80" />
                  <circle cx="2.13" cy="8.62" r="0.6" data-id="element-81" />
                  <circle cx="4.27" cy="8.62" r="0.6" data-id="element-82" />
                  <circle cx="6.4" cy="8.62" r="0.6" data-id="element-83" />
                  <circle cx="8.53" cy="8.62" r="0.6" data-id="element-84" />
                  <circle cx="10.67" cy="8.62" r="0.6" data-id="element-85" />
                  <circle cx="1.07" cy="9.69" r="0.6" data-id="element-86" />
                  <circle cx="3.2" cy="9.69" r="0.6" data-id="element-87" />
                  <circle cx="5.33" cy="9.69" r="0.6" data-id="element-88" />
                  <circle cx="7.47" cy="9.69" r="0.6" data-id="element-89" />
                  <circle cx="9.6" cy="9.69" r="0.6" data-id="element-90" />
                  <circle cx="11.73" cy="9.69" r="0.6" data-id="element-91" />
                  <circle cx="2.13" cy="10.77" r="0.6" data-id="element-92" />
                  <circle cx="4.27" cy="10.77" r="0.6" data-id="element-93" />
                  <circle cx="6.4" cy="10.77" r="0.6" data-id="element-94" />
                  <circle cx="8.53" cy="10.77" r="0.6" data-id="element-95" />
                  <circle cx="10.67" cy="10.77" r="0.6" data-id="element-96" />
                  <circle cx="1.07" cy="11.85" r="0.6" data-id="element-97" />
                  <circle cx="3.2" cy="11.85" r="0.6" data-id="element-98" />
                  <circle cx="5.33" cy="11.85" r="0.6" data-id="element-99" />
                  <circle cx="7.47" cy="11.85" r="0.6" data-id="element-100" />
                  <circle cx="9.6" cy="11.85" r="0.6" data-id="element-101" />
                  <circle cx="11.73" cy="11.85" r="0.6" data-id="element-102" />
                </g>
              </svg>
              <div className="text-3xl font-bold text-red-600" data-id="element-103">USA Made</div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-104">
              Moline Mounted Units manufactured in the USA
            </p>
          </div>
          <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 text-center shadow-lg" data-id="element-105">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-106">
              {/* Stock Boxes Icon */}
              <img src="https://cdn.magicpatterns.com/uploads/39mcgsrxvCaJvaa7cRaTnj/icon2.png" alt="Large Inventory" className="w-10 h-10 object-contain" data-id="element-107" />
              <div className="text-3xl font-bold text-red-600" data-id="element-108">
                Large Inventory
              </div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-109">
              Extensive stock for fast fulfillment
            </p>
          </div>
          <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 text-center shadow-lg" data-id="element-110">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-111">
              {/* US Map with Truck Icon */}
              <img src="https://cdn.magicpatterns.com/uploads/sXnWEHFS96wRzFasPiMGtC/icon3.png" alt="Nationwide Shipping" className="w-12 h-10 object-contain" data-id="element-112" />
              <div className="text-3xl font-bold text-red-600" data-id="element-113">Nationwide</div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-114">
              Shipping from multiple locations
            </p>
          </div>
        </div>
      </div>
    </section>;
}